import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

Vue.use(Vuex)
const state = {
  managerId: '',
  account: '',
  nickname: '',
  roleType: '',
}
const actions = {
  manager_id_action({ commit }, id) {
    commit('manager_id_mutation', id)
  },
  account_action({ commit }, account) {
    commit('account_mutation', account)
  },
  nickname_action({ commit }, nickname) {
    commit('nickname_mutation', nickname)
  },
  role_type_action({ commit }, roleType) {
    commit('role_type_mutation', roleType)
  },
  signout_action({ commit }) {
    commit('signout_mutation')
  },
}
const mutations = {
  manager_id_mutation(state, id) {
    state.managerId = id
  },
  account_mutation(state, account) {
    state.account = account
  },
  nickname_mutation(state, nickname) {
    state.nickname = nickname
  },
  role_type_mutation(state, roleType) {
    state.roleType = roleType
  },
  signout_mutation(state) {
    state.managerId = '';
    state.account = '';
    state.nickname = '';
    state.roleType = '';
  },
}
const getters = {}
export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  plugins: [vuexLocal.plugin]
})



// WEBPACK FOOTER //
// ./src/store/store.js